import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';

export default mergeStyleSets({
  root: {
    backgroundColor: theme.palette.neutralWhite,
  },
});
